document.querySelectorAll('[data-skinny-editor]').forEach(root => {
  const form = root.querySelector('[data-product-form]');
  const dock = form.querySelector('[data-skinny-dock]');
  const gallery = root.querySelector('[data-product-gallery]');
  const boundary = root.querySelector('[data-preview-boundary]');
  const image = root.querySelector('[data-artwork-preview]');
  const text = root.querySelector('[data-text-preview]');
  const upload = form.querySelector('[data-artwork-upload]');
  const name = form.querySelector('[data-personalization]');
  const namePanel = name.closest('[data-design-panel]');
  const choices = form.querySelector('[data-skinny-choices]');
  const controls = Object.fromEntries([...form.querySelectorAll('[data-skinny-control]')].map(el => [el.dataset.skinnyControl, el]));
  const fonts = {classic:'SkinnyClassic, Georgia, serif',script:'SkinnyScript, cursive',modern:'Arial, sans-serif',serif:'Georgia, serif',clean:'Verdana, sans-serif',typewriter:'Courier New, monospace'};
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  let moved = false;
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns, 'svg');
  svg.setAttribute('width', '0'); svg.setAttribute('height', '0');
  const filter = document.createElementNS(ns, 'filter'); filter.id = 'skinny-art-tint';
  const matrix = document.createElementNS(ns, 'feColorMatrix'); matrix.setAttribute('type', 'matrix');
  filter.append(matrix);
  const metalFilter = document.createElementNS(ns, 'filter'); metalFilter.id = 'skinny-art-metal';
  metalFilter.setAttribute('color-interpolation-filters', 'sRGB');
  const metalLight = document.createElementNS(ns, 'feColorMatrix');
  metalLight.setAttribute('type','matrix');
  metalLight.setAttribute('values','0.16 0.536 0.054 0 .25 0.16 0.536 0.054 0 .25 0.16 0.536 0.054 0 .25 0 0 0 1 0');
  metalLight.setAttribute('result','engraveLight');
  const metalPaint = document.createElementNS(ns,'feImage'); metalPaint.setAttribute('result','metalPaint');
  metalPaint.setAttribute('preserveAspectRatio','none');
  const metalBlend = document.createElementNS(ns,'feBlend'); metalBlend.setAttribute('in','metalPaint'); metalBlend.setAttribute('in2','engraveLight'); metalBlend.setAttribute('mode','multiply');
  const metalClip = document.createElementNS(ns,'feComposite'); metalClip.setAttribute('in2','SourceGraphic'); metalClip.setAttribute('operator','in');
  metalFilter.append(metalLight,metalPaint,metalBlend,metalClip); svg.append(filter, metalFilter); root.append(svg);
  const metals = {
    silver:['#92989d','#eef0f1','#b7bdc1','#dde0e2'],
    rose:['#a5654a','#f1c3a3','#b8795b','#e3ac86'],
    ghost:['#151619','#62666b','#26282c','#41454b'],
    multi:['#56bac5','#838ccd','#b37ab7','#e0bb76']
  };
  let paintedMetal = '';
  const selectTab = tab => {
    form.querySelectorAll('[data-skinny-tab]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.skinnyTab === tab)));
    form.querySelectorAll('[data-skinny-pane]').forEach(el => { el.hidden = el.dataset.skinnyPane !== tab; });
  };
  form.querySelectorAll('[data-skinny-tab]').forEach(el => el.addEventListener('click', () => selectTab(el.dataset.skinnyTab)));
  const openEditor = (tab, collapse = true) => {
    if (!moved) {
      dock.querySelector('[data-skinny-gallery]').append(gallery);
      dock.querySelector('[data-skinny-name-field]').append(namePanel);
      moved = true;
    }
    dock.hidden = false;
    namePanel.hidden = false;
    name.disabled = false;
    choices.hidden = false;
    root.classList.add('skinny-editing');
    if (collapse) {
      root.classList.add('skinny-choices-collapsed');
      choices.setAttribute('aria-expanded', 'false');
    }
    selectTab(tab);
    requestAnimationFrame(render);
  };
  function render() {
    const laser = !form.querySelector('[data-decoration-full-color]')?.checked;
    const colorField = [...form.querySelectorAll('[data-option-position]')].find(field => field.dataset.optionName?.includes('color'));
    const color = (colorField?.matches('select') ? colorField.value : colorField?.querySelector('select, input:checked')?.value || '').toLowerCase();
    const finish = color.includes('rose') ? 'rose' : color.includes('ghost') ? 'ghost' : color.includes('multi') || color.includes('prism') ? 'multi' : 'silver';
    const palette = metals[finish];
    if (paintedMetal !== finish) {
      const stops = palette.map((hex,index) => `<stop offset="${index/(palette.length-1)*100}%" stop-color="${hex}"/>`).join('');
      const paint = `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><defs><linearGradient id="metal">${stops}</linearGradient></defs><rect width="100" height="100" fill="url(#metal)"/></svg>`;
      metalPaint.setAttribute('href',`data:image/svg+xml,${encodeURIComponent(paint)}`);
      text.style.setProperty('--engraving-gradient',`linear-gradient(110deg,${palette.join(',')})`);
      paintedMetal = finish;
    }
    const metalNote = form.querySelector('[data-skinny-color-note]');
    metalNote.textContent = metalNote.dataset[finish];
    const finishProperty = form.querySelector('[data-skinny-metal-property]');
    finishProperty.disabled = !laser; finishProperty.value = finish;
    if (laser) form.querySelector('[data-decoration-help]').textContent = metalNote.dataset[finish];
    if (!moved) return;
    name.disabled = false;
    namePanel.hidden = false;

    const w = boundary.clientWidth;
    const h = boundary.clientHeight;
    if (!w || !h) return;
    const ratio = image.naturalWidth && image.naturalHeight ? image.naturalHeight / image.naturalWidth : 1;
    const width = Math.min(Number(controls.width.value), 2.75, 5.5 / ratio);
    const height = width * ratio;
    image.style.width = `${width / 2.75 * 100}%`;
    image.style.height = `${height / 5.5 * 100}%`;
    const photoWidth = width / 2.75 * w;
    image.style.left = `${photoWidth / 2 + Number(controls.photoX.value) / 100 * (w-photoWidth)}px`;
    image.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
    image.style.margin = '0';
    image.style.maxWidth = '100%'; image.style.maxHeight = '100%';
    image.style.top = `${height / 5.5 * 50 + Number(controls.photoY.value) / 100 * (100 - height / 5.5 * 100)}%`;
    const hex = controls.artColor.value;
    const rgb = [1,3,5].map(i => parseInt(hex.slice(i,i+2),16)/255);
    matrix.setAttribute('values', rgb.map(v => `${0.2126*v} ${0.7152*v} ${0.0722*v} 0 0`).join(' ') + ' 0 0 0 1 0');
    image.style.setProperty('filter', laser ? 'url(#skinny-art-metal)' : controls.photoMode.value === 'single' ? 'url(#skinny-art-tint)' : 'none', 'important');
    image.style.setProperty('mix-blend-mode', 'normal', 'important');
    const requested = Number(controls.nameSize.value) / 5.5 * h;
    const family = fonts[controls.font.value];
    context.font = `${requested}px ${family}`;
    const length = context.measureText(name.value.trim()).width;
    const size = length > w * .96 ? requested * w * .96 / length : requested;
    text.textContent = name.value.trim(); text.hidden = !text.textContent;
    text.style.fontFamily = family; text.style.fontSize = `${size}px`; text.style.fontWeight = '400';
    text.style.lineHeight = '1.2'; text.style.whiteSpace = 'nowrap';
    const textWidth = Math.min(length * size / requested, w * .96);
    text.style.width = `${Math.max(1,textWidth)}px`;
    text.style.left = `${Math.max(1,textWidth)/2 + Number(controls.nameX.value)/100 * (w-Math.max(1,textWidth))}px`;
    text.style.right = 'auto';
    text.style.top = `${size * .6 + Number(controls.nameY.value) / 100 * (h-size*1.2)}px`;
    text.style.transform = 'translate(-50%, -50%)';
    text.style.setProperty('color', laser ? palette[1] : controls.nameColor.value, 'important');
    text.style.setProperty('mix-blend-mode', 'normal', 'important');
    text.style.textShadow = 'none';
    text.classList.toggle('skinny-metal-text', laser);
    form.querySelector('[data-skinny-name-color-field]').hidden = laser;
    controls.nameColor.closest('.skinny-editor-row').classList.toggle('is-metal',laser);
    controls.photoMode.closest('.skinny-editor-row').hidden = laser;
    for (const key of ['nameColor','photoMode','artColor']) controls[key].disabled = laser;
    const tintVisible = !laser && controls.photoMode.value === 'single';
    form.querySelector('[data-skinny-art-color-field]').hidden = !tintVisible;
    controls.artColor.disabled = !tintVisible;
    controls.photoMode.closest('.skinny-editor-row').classList.toggle('has-color', tintVisible);
    for (const key of ['nameColor', 'artColor']) controls[key].parentElement.style.setProperty('--swatch', controls[key].value);
    form.querySelector('[data-skinny-color-note]').hidden = !laser;
    form.querySelector('[data-skinny-dimensions]').textContent = `${width.toFixed(2)}″ × ${height.toFixed(2)}″`;
    form.querySelector('[data-skinny-height]').value = `${height.toFixed(2)} inches`;
    form.querySelector('[data-skinny-name-height]').value = `${(size / h * 5.5).toFixed(3)} inches`;
    if (form.querySelector('[data-reuse-artwork]')?.checked) { name.disabled = true; text.hidden = true; }
    controls.width.value = width.toFixed(2);
  }
  form.querySelectorAll('[data-skinny-center]').forEach(button => button.addEventListener('click', () => {
    const prefix = button.dataset.skinnyCenter;
    controls[`${prefix}X`].value = '50'; controls[`${prefix}Y`].value = '50'; render();
  }));
  choices.addEventListener('click', () => {
    const collapsed = root.classList.toggle('skinny-choices-collapsed');
    choices.setAttribute('aria-expanded', String(!collapsed));
    if (collapsed) dock.scrollIntoView({behavior:'smooth',block:'start'});
  });
  upload.addEventListener('change', () => {
    const file = upload.files?.[0];
    if (file && ['image/png','image/jpeg','image/webp','image/svg+xml'].includes(file.type)) {
      openEditor('photo');
      const button = form.querySelector('[data-design-mode="text"]');
      if (button.getAttribute('aria-pressed') !== 'true') button.click();
      selectTab('photo');
      dock.scrollIntoView({behavior:'smooth',block:'start'});
    }
  });
  image.addEventListener('load', render);
  name.addEventListener('input', render);
  form.querySelector('[data-design-mode="text"]').addEventListener('click', () => {
    setTimeout(() => {
      if (form.querySelector('[data-design-mode="text"]').getAttribute('aria-pressed') === 'true') openEditor('name');
    }, 0);
  });
  form.addEventListener('change', () => setTimeout(render, 0));
  form.querySelector('[data-design-mode="previous"]').addEventListener('click', () => { root.classList.remove('skinny-choices-collapsed'); choices.setAttribute('aria-expanded', 'true'); render(); });
  Object.values(controls).forEach(el => el.addEventListener('input', render));
  form.querySelector('[data-skinny-change]').addEventListener('click', () => { upload.disabled = false; upload.click(); });
  form.querySelector('[data-skinny-remove]').addEventListener('click', () => {
    upload.value = ''; image.removeAttribute('src'); image.classList.remove('is-visible');
    form.querySelector('[data-artwork-status]').textContent = '';
    form.querySelector('[data-skinny-height]').value = '';
    render();
  });
  new ResizeObserver(render).observe(boundary);
  document.fonts.ready.then(render);
});

